import React, { Component } from "react";
import { DatePicker, Button, Select,AutoComplete,Input,message,Icon,Modal } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import API_URL from "../../../common/url";
import Fetch from "../../../common/Fetch";
import ExportUtil from '../../../common/ExportUtil';
import UploadFile from '../../common/UploadFile';
import $ from "../../../common/AjaxRequest";
import moment from "moment";

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;
const { Option } = Select;
const currencys =[
    {currency:"人民币",currencyTypeCode:'CNY'},
    {currency:"美元",currencyTypeCode:'USD'},
    {currency:"欧元",currencyTypeCode:'EUR'},
    {currency:"英镑",currencyTypeCode:'GBP'},
    {currency:"日元",currencyTypeCode:'JPY'},
    {currency:"港元",currencyTypeCode:'HKD'},
];

class Filter extends Component {
    state = {
        maxDate: moment(),
        visible:false,
        startMonth:null
    };

    search = () => {
        this.props.search();
    };

    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    };

    // downTemplate = (params) => {
    //     ExportUtil.export(params, null, API_URL.dashboard.getAccountsReceivableImport);
    //     message.success('正在下载中!')
    // }


    queryTaskStatus = () => {
        const options = {
            method: 'POST',
            url: API_URL.dashboard.accountsReceivableSync,
            data: {},
            dataType: 'json',
            doneResult: res => {
                // const { data } = res;
                // const { status } = data || {};
                // if (status === 'COMPLETED') {
                //     Modal.success({ title: '数据统计任务成功' });
                // } else {
                //     Modal.warning({ title: '刷新统计任务正在进行中，请稍后再试！' });
                // }
                console.log(res);
            }
        }
        $.sendRequest(options);
    }
    

    render() {
        // const { saveParams ,visible,startMonth } = this.state;
        const {searchParams} = this.props
        const currencyOption = currencys.map(d => <Option key={d.currencyTypeCode}>{d.currency}</Option>);
        return (
            <div>
                <div className="search-bar" style={{marginBottom:'5px',width:'100%',justifyContent:'space-between'}}>
                    <div>
                        <div className="search-item" style={{display:'inline-block'}}>
                            <label className="ui-label" style={{margin:'0 10px'}}>生效日期</label>
                                <MonthPicker
                                    format={monthFormat}
                                    allowClear={true}
                                    placeholder="选择月份"
                                    defaultValue={moment(searchParams.startEffectDate)}
                                    style={{width:'120px'}}
                                    disabledDate={(current)=>{return current && current.valueOf() > Date.now();}}
                                    onChange={(date, dateString) => this.props.onMonthChange(date, dateString ,'startEffectDate')}
                                />
                            <label className="ui-label" style={{margin:'0 10px',fontSize:'20px'}}>-</label>
                                <MonthPicker
                                    format={monthFormat}
                                    allowClear={true}
                                    placeholder="选择月份"
                                    defaultValue={moment(searchParams.endEffectDate)}
                                    style={{width:'120px'}}
                                    disabledDate={(current)=>{return current && current.valueOf() > Date.now();}}
                                    onChange={(date, dateString) => this.props.onMonthChange(date, dateString ,'endEffectDate')}
                                />
                        </div>
                        <div className="search-item" style={{display:'inline-block'}}>
                            <label className="ui-label">币种</label>
                            <Select
                                allowClear={true}
                                filterOption={false}
                                placeholder="请选择"
                                style={{width: 100}}
                                className="multiple-stage"
                                onChange={value => this.props.handleChange(value, 'currencyTypeCode')}
                            >
                                {currencyOption}
                            </Select>
                    </div>
                    </div>
                    
                    <div className="search-bar flex-end" >
                        <div className="search-item">
                            <Button type="primary" onClick={this.search}>搜索</Button>
                            <Button type="primary" onClick={()=>{this.props.export()}}>导出</Button>
                        </div>
                    </div>
                    <div className ="rate-history flex-end" style={{paddingTop:'10px'}}>
                        <a onClick={() => this.props.showRateHistory()} >
                            <i className="icon iconfont">&#xe630;</i><span>存档历史</span>
                        </a>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/contractManagement/currencyExchangeRate/Filter.js